import type { CategoryStat } from '@/modules/projects'
import { type Transaction, transactionKey } from '@/modules/projects'
import type { CategoryStatsRow } from '../types'

export const outlierCategoryKey = (outlier: Transaction) => {
  const detail = outlier.categoryDetail?.trim()
  return detail && detail.length > 0 ? detail : outlier.category
}

export const groupOutliersByCategory = (outliers: Transaction[]) => {
  const byCategory = new Map<string, Transaction[]>()
  for (const outlier of outliers) {
    const key = outlierCategoryKey(outlier)
    const existing = byCategory.get(key) ?? []
    existing.push(outlier)
    byCategory.set(key, existing)
  }
  return byCategory
}

export const toCategoryRows = (
  categoryStats: CategoryStat[],
  outliersByCategory: Map<string, Transaction[]>,
): CategoryStatsRow[] =>
  categoryStats
    .map((stat) => {
      const outliersForCategory = outliersByCategory.get(stat.category) ?? []
      const outlierAmount = outliersForCategory.reduce(
        (sum, outlier) => sum + outlier.amount,
        0,
      )
      const sign = stat.totalAmount < 0 ? -1 : 1

      return {
        id: stat.category,
        category: stat.category,
        count: stat.count,
        upperBound: sign * stat.upperBoundOrig,
        outlierCount: outliersForCategory.length,
        outlierAmount,
      }
    })
    .sort((first, second) => second.outlierCount - first.outlierCount)

export const matchOutlierTransactions = (
  outliers: Transaction[],
  transactions: Transaction[],
): Transaction[] => {
  if (outliers.length === 0 || transactions.length === 0) return []
  const outlierKeys = new Set(outliers.map(transactionKey))
  return transactions.filter((transaction) =>
    outlierKeys.has(transactionKey(transaction)),
  )
}
